import managedBackground from '../utils/managedBackground';

export default function renderThemeBackgrounds() {
  managedBackground({
    widgetConfigName: 'backgroundHeader',
    widgetConfigOpts: backgroundHeaderOpts,
    widgetConfigDestination: 'header',
    widgetConfigContainerClass: 'managed-bg',
  });
  managedBackground({
    widgetConfigName: 'backgroundFooter',
    widgetConfigOpts: backgroundFooterOpts,
    widgetConfigDestination: 'footer',
    widgetConfigContainerClass: 'managed-bg',
  });
  managedBackground({
    widgetConfigName: 'backgroundBody',
    widgetConfigOpts: backgroundBodyOpts,
    widgetConfigDestination: 'body',
    widgetConfigContainerClass: 'custom-body-bg',
  });
}
